<template>
  <div>
    <div class="selectBoxWithLabel" :class="{ isPc: !isSp }">
      <InputLabel
        class="labelArea"
        :class="{ isPc: !isSp, isHasLabel: !isSp && (required || optional), isPcModal: isPcModal }"
        :required="required"
        :optional="optional"
        :is-pc-modal="isPcModal"
        :is-sotsunen="isSotsunen"
      >
        {{ areaLabel }}
      </InputLabel>
      <div
        class="inputsArea"
        :class="{
          isPc: !isSp,
          todofuken: areaLabel === '都道府県',
          gakunen: areaLabel.includes('学年') && !isProfileEditPage,
          isProfileEditPage: isProfileEditPage,
        }"
      >
        <SelectBox
          v-model="selected"
          :placeholder-value="placeholder"
          :has-error="hasError"
          :select-list="selectList"
          :disabled="disabled"
          :is-pc-modal="isPcModal"
          :optional="optional"
          @change="onChange"
        />
      </div>
    </div>
    <div class="underInputArea" :class="{ isPc: !isSp, isPcModal: isPcModal }">
      <PartialErrorMessage :is-sp-flg="true" :error="errorFromOuter" class="partialErrorComponent" />
    </div>
  </div>
</template>

<script>
import InputLabel from '../Text/InputLabel.vue';
import SelectBox from './SelectBox.vue';
import PartialErrorMessage from '../PartialErrorMessage.vue';

export default {
  name: 'SelectBoxWithLabel',
  components: {
    InputLabel,
    SelectBox,
    PartialErrorMessage,
  },
  props: {
    areaLabel: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * 外部からのエラー
     * このコンポーネント自体はエラーを発出しない。
     * が、『未選択エラー』を外部から入れ込むケースがある。
     */
    errorFromOuter: {
      type: String,
      required: false,
      default: '',
    },
    selectList: {
      type: Array,
      required: true,
      default: () => [],
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    inputValue: {
      type: String,
      required: false,
      default: '',
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    isProfileEditPage: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 資料請求確認画面PC、 予約確認画面PCの時のみtrue
     * 両画面の変更フォームをモーダル内に表示する際にスタイル調整するため。
     */
    isPcModal: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    isSotsunen: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      selected: this.inputValue,
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    hasError() {
      // errorFromOuterがfalsyならエラーない
      if (!this.errorFromOuter) return false;
      // errorFromOuterがlengthもってるならエラーあり
      if (this.errorFromOuter.length) return true;
      return false;
    },
  },
  watch: {
    inputValue() {
      this.selected = this.inputValue;
    },
  },
  methods: {
    onChange() {
      this.$emit('change', this.selected);
      this.$emit('watchValidation');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.selectBoxWithLabel {
  .labelArea.isPc {
    width: 120px;
    margin: auto 0;

    &.isHasLabel {
      width: 184px;
    }

    &.isPcModal {
      width: 116px;
    }
  }

  .inputItem.isPc {
    width: 432px;
  }

  &.isPc {
    display: flex;
  }
}

.underInputArea.isPc {
  margin-left: 184px;

  &.isPcModal {
    margin-left: 148px;
  }
}

.inputLabel {
  display: block;
  font-weight: bold;
  line-height: $text-line-height-default;
  color: $color-text-secondry;
  font-size: $text-size-paragraph2;
  margin-bottom: 8px;
}

.inputsArea {
  display: flex;

  &.isPc.todofuken {
    width: 213px;
  }

  &.isPc.gakunen {
    width: 316px;
  }

  &.isPc.isProfileEditPage {
    width: 432px;
  }
}

.hasError,
.hasError:focus {
  border: $border-alert;
}

.partialErrorComponent {
  margin-top: 8px;
}
</style>
